<template>
  <div class="bigBox">
    <div class="boxSon">
      <!--<header>-->
      <!--<span></span><p><b>【张三】</b>意见反馈获得10积分</p>-->
      <!--</header>-->
      <article>
        <ul class="evalTags">
          <li
            v-for="(item, index) of evalTags"
            :class="{ evalTagsBoy: index == evalTagsBoy }"
            :key="index"
            @click="evalTagsMeth($event, index)"
          >
            {{ item.tags }}
          </li>
        </ul>
        <textarea
          v-model="textinput"
          name=""
          id="afterEval"
          @blur="input_blur"
          :placeholder="placeholderVal[evalTagsBoy]"
        ></textarea>
        <p>{{ textNum }}/200</p>
        <div class="evalPhotoBox">
          <!--<ul class="evalPhoto">-->
          <!--<li><img src="../../assets/images/add.png"></li>-->
          <!--</ul>-->
          <van-uploader
            v-model="fileList"
            :max-count="5"
            preview-size="0.59rem"
            upload-icon="plus"
          />
          <span>最多上传5张图片</span>
        </div>
      </article>
      <div class="contact" v-if="evalTagsBoy == 2" style="margin-bottom: 0.1rem">
        <b>手机型号</b>
        <input type="text" v-model="model" placeholder="请输入手机型号，以便我们测试(选填)" />
      </div>
      <div class="contact" style="margin-bottom: 0.1rem">
        <b>联系方式</b>
        <div class="security-code" v-if="time == 0" @click="chooseCountryClick">
          +{{ areaCode }}
          <img src="../../assets/images/jt6.png" />
        </div>

        <input type="number" maxlength="11" v-model="contact" placeholder="手机号（必填）" />
      </div>
      <div class="contact" style="margin-bottom: 0.1rem">
        <!--        <b>联系方式</b>-->
        <input
          type="text"
          v-model="codeValue"
          placeholder="请输入右边4位数字或字母"
          @keyup="codeChange"
        />
        <div class="codeImg" ref="codeImg" @click="getCodeImg">
          <img :src="codeImg" />
        </div>
      </div>
      <div class="contact">
        <!--        <b>联系方式</b>-->
        <input type="text" v-model="authCode" placeholder="请输入短信验证码" />
        <button
          class="sendcode"
          :class="passFlag ? 'gainRed' : ''"
          v-if="time == 0"
          @click="sendAgain"
        >
          获取验证码
        </button>
        <button class="sendcode" v-if="time != 0">{{ time }}s后重新发送</button>
      </div>
    </div>
    <footer :class="{ graybtn: btnControl }">
      <div class="prompt">
        一经采纳
        <br />
        我们会奉上金币呦～
      </div>
      <img src="../../assets/images/jt1.png" />
      <button class="submit" @click="submit">提交</button>
    </footer>
    <div class="homeBtn" @click="feedbackClick">
      <img src="../../assets/images/fankui.png" />
    </div>
    <van-popup v-model="codeShow" position="right" :style="{ height: '100%' }">
      <choose-country :type="'feedback'" @on-area-code="onAreaCode"></choose-country>
    </van-popup>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { isWeixin, fenxiang, basepath, random_string } from '../../assets/common/js/config'
import chooseCountry from '@/components/login/chooseCountry'
import Vue from 'vue'
import { Popup } from 'vant'

Vue.use(Popup)
export default {
  name: 'feedback',
  components: {
    chooseCountry
  },
  data() {
    return {
      evalTags: [
        { tags: '产品问题' },
        { tags: '订单问题' },
        { tags: '平台使用' },
        { tags: '体验问题' },
        { tags: '活动问题' },
        { tags: '内容' },
        { tags: '其他' }
      ],
      evalTagsBoy: 0,
      placeholderVal: [
        '产品使用过程中出现不适症状联系我们～',
        '对订单有任何疑问均可联系我们～',
        '不能愉快使用现有功能？上传相关页面截图能方便我们理解问题哟～',
        '产品使用过程中遇到任何体验不好的均可告诉我们～',
        '参与活动时遇到的任何情况均可联系我们～',
        '发现产品描述错误、宣传有误等记得告诉我们～',
        '在这里你可以畅所欲言～'
      ],
      textinput: '',
      textNum: 0,
      fileList: [],
      fileLen: null,
      model: '',
      contact: '',
      codeValue: '',
      authCode: '',
      areaCode: '86',
      codeImg: null, // 图片验证码
      timeout: null,
      time: 0,
      passFlag: false,
      sendstatus: false,
      imgpath: [],
      fileListWx: [],
      btnControl: false,
      codeShow: false
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'feedback' })
    }
    this.getCodeImg()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  watch: {
    textinput(n) {
      if (n.length > 200) {
        this.textNum = 200
      } else {
        this.textNum = n.length
      }
      this.textinput = this.textinput.slice(0, 200)
      console.log(n.length)
    }
  },
  methods: {
    initData() {
      Object.assign(this.$data, this.$options.data())
    },
    onAreaCode(n) {
      this.areaCode = n
      this.codeShow = false
    },
    // 获取图形验证码
    getCodeImg() {
      let width = this.$refs.codeImg.clientWidth
      let height = this.$refs.codeImg.clientHeight
      this.timeout = new Date().getTime() + '' + random_string(16)
      this.codeImg = this.$ajax.getValidateCode_URL(
        'sessionid=' + this.timeout + '&width=' + width + '&height=' + height
      )
    },
    sendAgain: function () {
      if (!this.passFlag) {
        return
      }
      this.authCode = ''
      var url =
        this.$ajax.getValidCode_URL +
        '?newVersion=1&mobile=' +
        this.contact +
        '&code=' +
        this.codeValue +
        '&sessionid=' +
        this.timeout +
        '&type=3&area_code=' +
        this.areaCode
      this.$toast.loading({
        mask: false,
        duration: 0,
        forbidClick: true,
        message: '发送中...'
      })
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          this.$toast({
            message: '发送成功',
            icon: require('../../assets/images/succ.png')
          })
          this.sendstatus = true
          this.time = 60
          this.countdown()
        }
      })
    },
    countdown: function () {
      var that = this
      var timer = setInterval(function () {
        that.time--
        if (that.time <= 0) {
          that.time = 0
          clearInterval(timer)
        }
      }, 1000)
    },
    chooseCountryClick: function () {
      this.codeShow = true
      // this.$router.replace({path: '/country',
      //   query: {
      //     type: 'feedback'
      //   }
      // })
    },
    codeChange: function () {
      this.checkInfo()
    },
    checkInfo: function () {
      this.passFlag = this.codeValue.length == 4
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
    cosUploadImage(file, fn) {
      console.log(file)
      var that = this
      that.$cos.uploadFile({
        key: '/communityreport_h5' + file.file.name,
        file: file.file,
        success: function (data) {
          that.imgpath.push(data)
          that.fileLen++
          if (that.fileLen >= that.fileList.length) {
            if (typeof fn === 'function') {
              fn()
            }
          } else {
            that.cosUploadImage(that.fileList[that.fileLen], function () {
              that.submitAxios()
            })
          }
        }
      })
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
    uploadImage(file, fn) {
      console.log(file)
      var imgName = 'comments'
      var blob = this.dataURLtoBlob(file.content)
      var newFile = this.blobToFile(blob, imgName)
      const url = this.$ajax.getOssWeb_URL
      var that = this
      that.$customRequestAjax(url).then(async (res) => {
        if (res.data.code === 200) {
          const { accessid, host, policy, signature, dir } = res.data.data
          const fd = new FormData()
          let str = that.random_string(16) + newFile.name + '.png'
          fd.append('OSSAccessKeyId', accessid)
          fd.append('policy', policy)
          fd.append('Signature', signature)
          fd.append('key', `${dir}${str}`)
          fd.append('Filename', `${dir}${str}`)
          fd.append('success_action_status', 200)
          fd.append('file', newFile)
          let config = {
            // 添加请求头
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          that.$axios.post(host, fd, config).then((res) => {
            if (res.status == 200 && res.statusText == 'OK') {
              // var img = that.ossImgUrl + `${dir}${str}`
              var img = `${dir}${str}`.replace('Uploads/', '')
              that.imgpath.push(img)
              that.fileLen++
              if (that.fileLen >= that.fileList.length) {
                if (typeof fn === 'function') {
                  fn()
                }
              } else {
                that.uploadImage(that.fileList[that.fileLen], function () {
                  that.submitAxios()
                })
              }
            }
          })
        }
      })
    },
    // 将base64转换为blob
    dataURLtoBlob: function (dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 将blob转换为file
    blobToFile: function (theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    random_string: function (n) {
      var num = Math.pow(10, n)
      return Math.ceil(Math.random() * num) + '' + new Date().getTime()
    },
    // deleteImg (file) {
    //   console.log('file', file)
    //   console.log('fileList', this.fileList)
    // },
    evalTagsMeth: function (e, idx) {
      console.log(e)
      this.evalTagsBoy = idx
    },
    feedbackClick: function () {
      this.$router.push({
        path: '/feedbacklist'
      })
    },
    submit: function () {
      if (this.textinput.replace(/\s+/g, '').length <= 0) {
        this.$toast('请填写你的意见')
        return
      } else if (this.contact.replace(/\s+/g, '').length <= 0) {
        this.$toast('手机号码不能为空')
        return
      } else if (this.codeValue.replace(/\s+/g, '').length <= 0) {
        this.$toast('图片验证码不能为空')
        return
      } else if (this.authCode.replace(/\s+/g, '').length <= 0) {
        this.$toast('手机验证码不能为空')
        return
      }
      this.$toast.loading({
        mask: false,
        message: '正在提交',
        duration: 0,
        forbidClick: true
      })
      this.fileLen = 0
      this.imgpath = []
      var that = this
      if (that.fileLen < that.fileList.length) {
        // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
        that[that.$cos.isCosSwitch == 1 ? 'cosUploadImage' : 'uploadImage'](
          that.fileList[that.fileLen],
          function () {
            that.submitAxios()
          }
        )
        // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
      } else {
        that.submitAxios()
      }
    },
    submitAxios() {
      var url = this.$ajax.addIdea_URL
      var that = this
      this.$ckeckgraphic({
        content: that.textinput,
        images: that.imgpath.length > 0 ? that.imgpath.join() : '',
        callback: () => {
          var data = {
            type: parseInt(that.evalTagsBoy + 1),
            description: that.textinput,
            phone_model: that.model,
            contact_way: that.contact,
            path1: that.imgpath[0] ? that.imgpath[0] : '',
            path2: that.imgpath[1] ? that.imgpath[1] : '',
            path3: that.imgpath[2] ? that.imgpath[2] : '',
            path4: that.imgpath[3] ? that.imgpath[3] : '',
            path5: that.imgpath[4] ? that.imgpath[4] : '',
            validatecode: that.authCode
          }
          console.log('imgpath', that.imgpath)
          if (!that.btnControl) {
            that.btnControl = true
            that.$customRequestAjax.post(url, data).then(function (res) {
              if (res.data.code === 200) {
                that.initData()
                that.$toast({
                  message: '提交成功',
                  icon: require('../../assets/images/succ.png')
                })
                setTimeout(function () {
                  that.feedbackClick()
                }, 500)
              } else {
                that.btnControl = false
              }
            })
          } else {
            that.$toast('请勿重复提交')
          }
        }
      })
    },
    input_blur() {
      // document.body.scrollTop = document.documentElement.scrollTop - 1
      setTimeout(() => {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight, 0))
      }, 100)
    },
    handlechange() {
      var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
      // var reg = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g;
      if (this.textinput.match(reg)) {
        this.textinput = this.textinput.replace(reg, '')
      }
      this.textinput = this.textinput.replace(/\s+/g, '')
    }
  }
}
</script>

<style scoped lang="scss">
.bigBox {
  min-height: 100%;
  display: flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -webkit-flex;
  display: -o-flex;
  flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  -o-flex-direction: column;
  .boxSon {
    flex: 1;
    -webkit-flex: 1;
    -o-flex: 1;
    -moz-flex: 1;
    -ms-flex: 1;
    border-top: 0.1rem solid #eeeeee;
  }
}
header {
  display: flex;
  display: -ms-flex;
  display: -webkit-flex;
  display: -moz-flex;
  display: -o-flex;
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
  -ms-justify-content: flex-start;
  -o--justify-content: flex-start;
  -moz--justify-content: flex-start;
  align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  height: 0.34rem;
  background: #fff;
  margin: 0.1rem 0.11rem;
  border-radius: 0.04rem;
  padding-left: 0.1rem;
  span {
    background: url('../../assets/images/tags1.png') no-repeat left top;
    background-size: 100% 100%;
    display: block;
    width: 0.47rem;
    height: 0.16rem;
    line-height: 0.16rem;
    text-align: center;
    font-size: 0.08rem;
  }
  p {
    font-size: 0.13rem;
    color: #333333;
  }
  b {
    color: #333;
    font-size: 0.13rem;
    border-left: 0.01rem solid #b8b8b8;
    margin-left: 0.08rem;
    padding-left: 0.08rem;
  }
  font-size: 0.14rem;
}
article {
  background: #fff;
  margin: 0 0.11rem;
  padding: 0 0.15rem 0.12rem;
  border-radius: 0.04rem;
  .evalTags {
    display: flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -o-flex;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    -o-flex-wrap: wrap;
    padding: 0.15rem 0 0;
    margin-bottom: 0.11rem;
    border-bottom: 0.01rem solid #efefef;
    li {
      width: 0.7rem;
      height: 0.27rem;
      text-align: center;
      color: #262626;
      font-size: 0.12rem;
      border: 0.01rem solid #606060;
      border-radius: 0.14rem;
      margin-right: 0.1rem;
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      justify-content: center;
      -webkit-justify-content: center;
      -moz-justify-content: center;
      -ms-justify-content: center;
      -o-justify-content: center;
      align-items: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      margin-bottom: 0.1rem;
      &:last-of-type {
        margin-right: 0;
      }
      &.evalTagsBoy {
        border: 0.01rem solid #fc0324;
        color: #fc0324;
      }
    }
  }
  #afterEval {
    display: block;
    width: 100%;
    min-height: 1.43rem;
    border: none;
    outline: none;
    line-height: 0.18rem;
    font-size: 0.13rem;
    color: #333;
    &::placeholder {
      font-size: 0.13rem;
      color: #999999;
      line-height: 0.18rem;
    }
  }
  p {
    font-size: 0.11rem;
    color: #b0b0b0;
    text-align: right;
  }
  .evalPhotoBox {
    display: -o-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: flex;
    align-items: flex-end;
    -webkit-align-items: flex-end;
    -o--align-items: flex-end;
    -moz--align-items: flex-end;
    -ms--align-items: flex-end;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    -o--flex-wrap: wrap;
    -moz--flex-wrap: wrap;
    -ms--flex-wrap: wrap;
    span {
      display: block;
      font-size: 0.11rem;
      color: #b0b0b0;
      margin-left: 0.02rem;
      margin-bottom: 0.08rem;
    }
  }
}
.contact {
  height: 0.45rem;
  background: #fff;
  margin: 0.1rem 0.11rem 0;
  padding: 0 0.15rem;
  display: flex;
  display: -ms-flex;
  display: -webkit-flex;
  display: -moz-flex;
  display: -o-flex;
  align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  border-radius: 0.04rem;
  margin-bottom: 1.15rem;
  .security-code {
    font-size: 0.13rem;
    height: 0.41rem;
    line-height: 0.4rem;
    margin-left: 0.1rem;
    /*border-bottom: 1px solid #5F6274;*/
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -o-flex;
    display: -moz-flex;
    align-items: center;
    -webkit-align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    -moz-align-items: center;
    img {
      width: 0.16rem;
      height: 0.16rem;
      padding: 0.06rem 0.05rem 0.06rem 0.03rem;
      display: block;
    }
  }
  b {
    display: block;
    font-size: 0.13rem;
    color: #000000;
    width: 20%;
    font-weight: 600;
  }
  input {
    font-size: 0.13rem;
    width: 80%;
    color: #999999;
    border: none;
    outline: none;
    margin-top: 0.01rem;
    &::placeholder {
      font-size: 0.13rem;
      color: #999999;
    }
  }
  .codeImg {
    height: 0.36rem;
    width: 34.5%;
    background: rgb(238, 238, 238);
    margin-left: 0.1rem;
    overflow: hidden;
    img {
      width: 100%;
      display: block;
    }
  }
  .sendcode {
    width: 32.5%;
    height: 0.37rem;
    line-height: 0.37rem;
    text-align: center;
    font-size: 0.12rem;
    color: #ffffff;
    display: block;
    border-width: 0;
    background: #eeeeee;
    &.gainRed {
      background: #fc0324;
    }
  }
}
footer {
  height: 0.45rem;
  background: #fc0324;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  &.graybtn {
    background: #ccc;
  }
  .prompt {
    font-size: 0.11rem;
    border-radius: 0.04rem;
    color: #5a5a5a;
    text-align: center;
    background: #fff;
    height: 0.48rem;
    padding: 0.08rem 0.24rem 0;
    position: absolute;
    top: -0.58rem;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    transform: translateX(-50%);
  }
  img {
    width: 0.12rem;
    height: 0.1rem;
    margin: -0.1rem auto 0;
  }
  .submit {
    width: 100%;
    display: block;
    margin: 0 auto;
    line-height: 0.45rem;
    background: none;
    border: none;
    outline: none;
    color: #fff;
    font-size: 0.13rem;
  }
}
.homeBtn {
  z-index: 10;
  position: fixed;
  right: 0.17rem;
  bottom: 0.8rem;
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
  -webkit-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
  -moz-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
  -ms-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
  -o-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
  display: flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -webkit-flex;
  display: -o-flex;
  flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  -o-flex-direction: column;
  justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -webkit-justify-content: center;
  -o-justify-content: center;
  align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  img {
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 0.2rem;
    display: block;
  }
  p {
    font-size: 0.09rem;
    color: #444444;
    line-height: 0.13rem;
  }
}
</style>
<style lang="scss">
.bigBox .van-icon__image {
  width: 0.36rem;
  height: 0.36rem;
}
</style>



// WEBPACK FOOTER //
// src/components/user/feedback.vue